// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hf","icon":"Haj","title":"Hal","text":"Hah"};